import React, { useRef, useState } from "react";
import InvoiceHTML from "./InvoiceHTML";
import html2pdf from "html2pdf.js";

const InvoiceDownloadBtn = ({ data }) => {
  const invoiceRef = useRef(null);
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadPDF = async () => {
    if (!invoiceRef.current || isDownloading) return;

    try {
      setIsDownloading(true);

      const element = invoiceRef.current;

      const options = {
        margin: [5, 5, 5, 5],
        filename: `Invoice-${data?.orderId || "invoice"}.pdf`,

        image: {
          type: "jpeg",
          quality: 0.98,
        },

        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          backgroundColor: "#ffffff",
          scrollX: 0,
          scrollY: 0,
        },

        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },

        pagebreak: {
          mode: ["css", "legacy"],
          avoid: [
            ".invoice-table tr",
            ".product-info",
            ".invoice-header",
            ".order-info-bar",
            ".addresses-section",
          ],
        },
      };

      await html2pdf()
        .set(options)
        .from(element)
        .save();

    } catch (error) {
      console.error("Invoice PDF Error:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      {/* Only Button */}
      <button
        type="button"
        className="status-action-btn btn-download"
        onClick={downloadPDF}
        disabled={isDownloading}
      >
        {isDownloading ? "Generating..." : "Download Invoice"}
      </button>

      {/* PDF Render Area */}
      <div className="invoice-pdf-render">
        <div ref={invoiceRef}>
          <InvoiceHTML data={data} />
        </div>
      </div>
    </>
  );
};

export default InvoiceDownloadBtn;